import { CheckCircle2, Expand, ImageOff, Trash2, Eye } from "lucide-react";
import { MARKET_LABEL } from "../valueFormat";
import { BookTag } from "./QuoteTable";
import { fmtTime, gameLabel, milestone } from "./omUtils";

const API = process.env.REACT_APP_BACKEND_URL;
export const shotImage = (id) => `${API}/api/value/screenshots/${id}/image`;
const STATUS = { used: ["Processed", "ok"], superseded: ["Superseded", "old"], removed: ["Lines removed", "old"], empty: ["Nothing saved", "bad"] };

function ShotCard({ s, market, game, names, onView, onDelete }) {
  const [label, cls] = STATUS[s.status] || STATUS.used;
  const r = (s.ranges || []).find((x) => x.market === market) || (s.ranges || [])[0];
  const who = (r?.players || []).map((id) => names[id]).filter(Boolean);
  return (
    <article className="om-shot" data-testid={`om-shot-${s.n}`}>
      <div className="om-shot-top">
        <b className="om-n">#{s.n}</b>
        <em className={`om-chip ${cls}`} data-testid={`om-shot-status-${s.n}`}>{cls === "ok" && <CheckCircle2 size={12} />}{label}</em>
        {s.has_image && <button type="button" className="om-expand" onClick={() => onView(s)} aria-label="Open screenshot" data-testid={`om-shot-expand-${s.n}`}><Expand size={15} /></button>}
      </div>
      <div className="om-shot-row">
        <button type="button" className="om-thumb" onClick={() => s.has_image && onView(s)} data-testid={`om-shot-thumb-${s.n}`}>
          {s.has_image ? <img src={shotImage(s.id)} alt={`Screenshot ${s.n}`} loading="lazy" /> : <ImageOff size={20} />}
        </button>
        <div className="om-shot-body">
          <span className="om-when">{fmtTime(s.uploaded_at)}</span>
          <strong>{gameLabel(game)}</strong>
          <span className="om-who">{who.slice(0, 2).join(", ")}{who.length > 2 ? ` +${who.length - 2}` : ""}</span>
          <span>{r ? `${MARKET_LABEL[r.market]} (${milestone(r.lo)}+ – ${milestone(r.hi)}+)` : "—"}</span>
          <span className="om-upd"><CheckCircle2 size={13} />{r?.n ?? s.priced ?? 0} milestones updated</span>
          <BookTag name={s.bookmaker} />
          {Object.keys(s.skipped || {}).length > 0 && <small className="om-why">{Object.entries(s.skipped).map(([k, n]) => `${n} × ${k}`).join(" · ")}</small>}
        </div>
      </div>
      <div className="om-shot-actions">
        {s.has_image && <button type="button" onClick={() => onView(s)} data-testid={`om-shot-view-${s.n}`}><Eye size={14} />View</button>}
        <button type="button" className="danger" onClick={() => onDelete(s)} aria-label="Delete screenshot" data-testid={`om-shot-delete-${s.n}`}><Trash2 size={14} /></button>
      </div>
    </article>
  );
}

export function ShotHistory({ shots, market, game, names, onView, onDelete, children }) {
  return (
    <aside className="om-panel om-history" data-testid="om-history">
      <h3>SCREENSHOT HISTORY ({shots.length})</h3>
      <div className="om-history-list">
        {!shots.length && <p className="om-empty">No screenshots for this game and market yet.</p>}
        {[...shots].sort((a, b) => b.uploaded_at.localeCompare(a.uploaded_at)).map((s) => (
          <ShotCard key={s.id} s={s} market={market} game={game} names={names} onView={onView} onDelete={onDelete} />
        ))}
      </div>
      <div className="om-drop-wrap" data-testid="om-upload">{children}</div>
    </aside>
  );
}
